const InventorySkeleton = () => {
  return (
    <div
      className="
        grid
        grid-cols-1
        gap-4

        p-5

        sm:px-7
        md:grid-cols-2
        xl:grid-cols-3
      "
    >
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="
            h-72

            animate-pulse

            rounded-xl

            border
            border-stroke

            bg-gray-2

            dark:border-strokedark
            dark:bg-meta-4
          "
        />
      ))}
    </div>
  );
};

export default InventorySkeleton;